import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import { useGetPreClaimsReasonList } from '../../hooks';

export const PreClaimsReasonSelect = ({
  placeholder = 'Select Reason',
  label = 'Reason',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
}) => {
  const { data: options, isLoading } = useGetPreClaimsReasonList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};
